import { apiService } from "../apiService";
import urlConfig from "../../../config/domain";
import LoginService from "../login/loginService";

export const AGetEquityLimits = (callback: CallableFunction) => {
	if (LoginService.pToken && LoginService.pToken.accType !== "CO") {
		apiService(
			{
				url: urlConfig.limits.equity,
				method: "POST",
				authType: "authtoken",
				body: {
					request: {
						requestType: "U",
						msgID: "",
						data: {},
						appID: urlConfig.appid,
						session: "",
						formFactor: "W"
					}
				}
			},
			callback
		);
	}
};

export const AGetCommLimits = (callback: CallableFunction) => {
	if (LoginService.pToken && LoginService.pToken.accType !== "EQ") {
		apiService(
			{
				url: urlConfig.limits.comm + LoginService.pToken.username,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};
